var DealLazyLoader;

DealLazyLoader = window.DealLazyLoader = {
  sleepyLoadImages: function() {
    return $('.sleepy-load').lazyload({
      skip_invisible: false
    });
  },
  init: function(payload, done) {
    return $(function() {
      $(document.body).on('modal-open', function(e, data) {
        return $('#' + data.id).find('.lazy-load').lazyload();
      });
      DealContentLoader.addOnLoadHandler(function() {
        Groupon.Utils.lazyLoadImages({
          skip_invisible: false
        });
        return DealLazyLoader.sleepyLoadImages();
      });
      return done();
    });
  }
};

module.exports = DealLazyLoader;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2RlYWxfbGF6eV9sb2FkZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2RlYWxfbGF6eV9sb2FkZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxHQUFpQixNQUFNLENBQUMsY0FBUCxHQUNmO0VBQUEsZ0JBQUEsRUFBa0IsU0FBQTtXQUNoQixDQUFBLENBQUUsY0FBRixDQUFpQixDQUFDLFFBQWxCLENBQTJCO01BQUMsY0FBQSxFQUFnQixLQUFqQjtLQUEzQjtFQURnQixDQUFsQjtFQUdBLElBQUEsRUFBTSxTQUFDLE9BQUQsRUFBVSxJQUFWO1dBQ0osQ0FBQSxDQUFFLFNBQUE7TUFDQSxDQUFBLENBQUUsUUFBUSxDQUFDLElBQVgsQ0FBZ0IsQ0FBQyxFQUFqQixDQUFvQixZQUFwQixFQUFrQyxTQUFDLENBQUQsRUFBSSxJQUFKO2VBQ2hDLENBQUEsQ0FBRSxHQUFBLEdBQU0sSUFBSSxDQUFDLEVBQWIsQ0FBZ0IsQ0FBQyxJQUFqQixDQUFzQixZQUF0QixDQUFtQyxDQUFDLFFBQXBDLENBQUE7TUFEZ0MsQ0FBbEM7TUFJQSxpQkFBaUIsQ0FBQyxnQkFBbEIsQ0FBbUMsU0FBQTtRQUNqQyxPQUFPLENBQUMsS0FBSyxDQUFDLGNBQWQsQ0FBNkI7VUFBQyxjQUFBLEVBQWdCLEtBQWpCO1NBQTdCO2VBQ0EsY0FBYyxDQUFDLGdCQUFmLENBQUE7TUFGaUMsQ0FBbkM7YUFJQSxJQUFBLENBQUE7SUFUQSxDQUFGO0VBREksQ0FITjs7O0FBZUYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
